import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils';
import { ImageElementType } from 'polotno/model/image-model';
import { VideoElementType } from 'polotno/model/video-model';

const getScaledImage = (imageWidth: number, imageHeight: number, pageWidth: number, pageHeight: number) => {
    const scale = Math.min(pageWidth / imageWidth, pageHeight / imageHeight);
    return {
        width: imageWidth * scale,
        height: imageHeight * scale,
    };
};

const getRect = (imageWidth: number, imageHeight: number, pageWidth: number, pageHeight: number) => {
    const { width, height } = getScaledImage(imageWidth, imageHeight, pageWidth, pageHeight);

    const center = {
        x: pageWidth / 2,
        y: pageHeight / 2,
    };

    return {
        x: center.x - width / 2,
        y: center.y - height / 2,
        width,
        height,
    };
};

const getElementDimensions = (element: ImageElementType | VideoElementType) => {
    if (checkPolotnoType(element, polotnoTypes.Avatar)) {
        return {
            width: element.width,
            height: element.height,
        };
    }

    return {
        width: element.custom.originalWidth,
        height: element.custom.originalHeight,
    };
};

export async function fitToPageElement(element: ImageElementType | VideoElementType): Promise<ImageElementType | VideoElementType> {
    const { page } = element;
    const pageWidth = page.store.width;
    const pageHeight = page.store.height;

    const imageSize = getElementDimensions(element);
    const rect = getRect(imageSize.width, imageSize.height, pageWidth, pageHeight);

    element.set({
        ...rect,
        rotation: 0,
    });

    return element;
}
